"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LeaveCourseModal = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _noty = require("noty");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _userProfile = require("user-profile");

var LeaveCourseModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(LeaveCourseModal, _Modal);

  function LeaveCourseModal() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, LeaveCourseModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(LeaveCourseModal)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.classList = ['modal', 'fade'];
    _this.innerWrapper = false;
    _this.hasModalTitleElement = false;
    return _this;
  }

  babelHelpers.createClass(LeaveCourseModal, [{
    key: "show",
    value: function show() {
      var _babelHelpers$get,
          _this2 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(LeaveCourseModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        element.querySelector('form').addEventListener('submit', function (event) {
          (0, _fetch.default)(location.href, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              leaveCourse: true,
              ajax: true
            })
          }).then(function (response) {
            (0, _userProfile.userProfileUpdated)();
            (0, _noty.showNotificationText)('You are no longer on this course.');
          });

          _this2.hide();

          event.preventDefault();
        });
        return element;
      });
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "\n\t\t\t<h3>Leave this course?</h3>\n\t\t\t<h4>Please note that when you leave a course that all of your progress will be removed and that it is non-reversible.</h4>\n\t\t\t<div class='modal-body-footer'>\n\t\t\t\t<form method='post'>\n\t\t\t\t\t<input type='hidden' name='leaveCourse' value='1'>\n\t\t\t\t\t<button data-spin='true' type='submit' class='btn btn-primary pull-right'>\n\t\t\t\t\t\tLeave Course\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class='btn btn-default pull-left' type='button' data-dismiss='modal'>\n\t\t\t\t\t\tCancel\n\t\t\t\t\t</button>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t";
    }
  }]);
  return LeaveCourseModal;
}(_base.default);

exports.LeaveCourseModal = LeaveCourseModal;

var _default = new LeaveCourseModal('leave-course-modal');

exports.default = _default;